import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["companyInfoSection", "paymentSection", "errorContainer"]

  async validateCompanyInfo(event) {
    event.preventDefault()
    const form = this.element
    const formData = new FormData(form)

    const response = await fetch('/accounts/registrations/validate_company_info', {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })

    const data = await response.json()

    if (data.valid) {
      // If company info is valid, trigger payment submission
      this.element.dispatchEvent(new CustomEvent('company-info-valid'))
    } else {
      this.displayErrors(data.errors)
    }
  }

  displayErrors(errors) {
    this.clearErrors()
    
    let hasCompanyInfoErrors = false

    Object.entries(errors).forEach(([field, messages]) => {
      if (field === 'base') {
        const errorElement = document.createElement('div')
        errorElement.className = 'error-message text-red-500 text-sm mt-1'
        errorElement.textContent = Array.isArray(messages) ? messages.join(', ') : messages
        this.errorContainerTarget.appendChild(errorElement)
        hasCompanyInfoErrors = true
      } else {
        this.displayFieldError(field, messages)
        hasCompanyInfoErrors = true
      }
    })

    if (hasCompanyInfoErrors) {
      this.companyInfoSectionTarget.scrollIntoView({ behavior: 'smooth' })
    }
  }

  displayFieldError(field, messages) {
    const inputField = this.element.querySelector(`[name="account[${field}]"]`)
    if (inputField) {
      const errorElement = document.createElement('div')
      errorElement.className = 'error-message text-red-500 text-sm mt-1'
      errorElement.textContent = Array.isArray(messages) ? messages.join(', ') : messages
      inputField.parentNode.insertBefore(errorElement, inputField.nextSibling)
      inputField.classList.add('border-red-500')
    }
  }

  clearErrors() {
    console.log("cleairing errors ", document.querySelectorAll('.error-message'))
    this.element.querySelectorAll('.error-message').forEach(el => el.remove())
    this.element.querySelectorAll('.border-red-500').forEach(el => el.classList.remove('border-red-500'))
  }

  scrollToPaymentSection() {
    this.paymentSectionTarget.scrollIntoView({ behavior: 'smooth' })
  }
}